/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Validation_HintInputs */



/**
* | output |
* | --- |
* | "Each row needs a promo and at least 1 copy. Not saved until fixed." |
*
* @param {Promos_Validation_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_validation_hint = /** @type {((inputs?: Promos_Validation_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Validation_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaque ligne doit avoir une promo et au moins 1 exemplaire. Non enregistré tant que ce n'est pas corrigé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cada fila necesita una promo y al menos 1 copia. No se guarda hasta corregirlo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cada linha precisa de uma promo e pelo menos 1 cópia. Não é salvo até corrigir.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ogni riga deve avere una promo e almeno 1 copia. Non salvato finché non è corretto.")
	return /** @type {LocalizedString} */ ("Each row needs a promo and at least 1 copy. Not saved until fixed.")
});